export const GLOBAL_STATE = 'Question'

export const QUESTION_BY_ID = 'QUESTION_BY_ID'
export const QUESTION_CREATE = 'QUESTION_CREATE'
export const QUESTION_DELETE = 'QUESTION_DELETE'
export const QUESTION_ALL = 'QUESTION_ALL'

export const QUESTION_TYPES = 'QUESTION_TYPES'
export const QUESTION_TYPES_COUNTS = 'QUESTION_TYPES_COUNTS'
